import {
  useEffect,
  useState,
} from 'react';
import {
  Button,
  Checkbox,
  Form, message,
  Modal,
  Spin,
} from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { useRequest } from 'ahooks';
import qs from 'query-string';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { getDictType } from '@/services/common';
import './index.less';
import SubjectBasicInfo from './components/SubjectBasicInfo';
import useKeepAlive from '@/hooks/useKeepAlive';
import { XMDD_BILLION_PRO } from '@/utils/mappingDict';
import AuthorizationInfo from '@/components/FormInfo/AuthorizationInfo';
import { billionProductAddApply, getBillionProductDetail, updateBillionProduct } from '@/services/projectScheduling';
import { getFileList } from '@/utils/fileDataUtil';

const formItemLayout = {
  labelCol: {
    sm: { span: 8 },
  },
  wrapperCol: {
    sm: { span: 24 },
  },
};
const curYear = dayjs().year();
export default function Application() {
  const [form] = Form.useForm();
  const Navigate = useNavigate();
  const { search } = useLocation();
  const { id } = qs.parse(search);
  const { userType, userInfo } = useSelector((state) => state);
  const [initialValues] = useState({
    // applicantName: user.displayName,
    // applicantNo: userType === 3 ? user.displayCode : user.idcardNo,
    initiationYear: dayjs(),
  });

  const [authInfoModal, setAuthInfoModal] = useState(false); // 授权书内容

  const generateFileInfo = (fileList) => fileList.map((file) => ({
    fileName: file.name || file.fileName,
    fileUrl: file?.response?.data || file.fileUrl || file.url,
  }));

  const { data: dict = {} } = useRequest(getDictType, { defaultParams: [XMDD_BILLION_PRO] });

  // 数据回显
  const { run: getBasicInfoRun, data } = useRequest(getBillionProductDetail, {
    manual: true,
    onSuccess(res) {
      if (res) {
        const {
          provinceId, cityId, areaId, projectProvinceId, projectCityId, projectAreaId, initiationYear, fileVos,
        } = res;
        form.setFieldsValue({
          ...res,
          area: [provinceId, cityId, areaId],
          projectArea: [projectProvinceId, projectCityId, projectAreaId],
          initiationYear: dayjs(String(initiationYear), 'YYYY'),
          fileVos: getFileList(fileVos),
        });
      }
    },
  });

  const { loading, run: add } = useRequest(billionProductAddApply, {
    manual: true,
    onSuccess() {
      message.success('提交成功');
      Navigate('/projectScheduling/myProject');
    },
  });

  const { loading: updateLoading, run: updateRun } = useRequest(updateBillionProduct, {
    manual: true,
    onSuccess() {
      message.success('更新成功');
      Navigate('/projectScheduling/myProject');
    },
  });

  useEffect(() => {
    if (!userInfo) return;

    form.setFieldsValue({
      applicantName: userInfo.displayName,
      applicantNo:
        userType === 3
          ? userInfo.displayCode
          : userInfo.idcardNo,
      initiationYear: dayjs(),
    });
  }, [userInfo, userType]);

  useEffect(() => {
    if (id) {
      getBasicInfoRun(id);
    }
  }, [id]);
  // 保证token不过期
  useKeepAlive();

  function onFinish() {
    form.validateFields().then((values) => {
      const val = {
        ...values,
        provinceId: values.area[0],
        cityId: values.area[1],
        areaId: values.area[2],
        area: undefined,
        projectProvinceId: values.projectArea[0],
        projectCityId: values.projectArea[1],
        projectAreaId: values.projectArea[2],
        projectArea: undefined,
        id,
        initiationYear: values.initiationYear.year().toString(),
        fileVos: generateFileInfo(values.fileVos),
      };
      if (id) {
        updateRun(val);
      } else {
        add(val);
      }
    }).catch(() => {
      setTimeout(() => {
        const errorList = document.querySelectorAll('.ant-form-item-has-error');
        errorList[0]?.scrollIntoView({
          block: 'center',
          behavior: 'smooth',
        });
      }, 500);
    });
  }

  function checkAuthorize(_, value) {
    if (!value) {
      return Promise.reject(new Error('勾选同意并接受'));
    }
    return Promise.resolve();
  }

  return (
    <div className="major-financing-application">
      <div className="content-width">
        <div className="margin-top20">
          <Spin spinning={false}>
            <Form
              {...formItemLayout}
              form={form}
              name="form"
              className="form"
              onFinish={onFinish}
              initialValues={initialValues}
            >
              <SubjectBasicInfo
                formRef={form}
                data={data}
                dict={{
                  ...dict, curYear,
                }}
              />
              <div className="authorize">
                <Form.Item
                  required
                  name="authorize"
                  wrapperCol={{ span: 24 }}
                  valuePropName="checked"
                  rules={[
                    { validator: checkAuthorize },
                  ]}
                >
                  <Checkbox
                    onChange={(e) => {
                      form.setFieldsValue({ authorize: false });
                      if (e.target.checked) {
                        setAuthInfoModal(true);
                      }
                    }}
                  >
                    您需要同意并接受
                    <Button type="link" className="authorize-name" onClick={() => setAuthInfoModal(true)}>《直通车平台业务授权协议》</Button>
                  </Checkbox>
                </Form.Item>
              </div>
              <div className="submit-btn-box">
                <Button type="primary" onClick={onFinish} loading={loading || updateLoading}>
                  提交
                </Button>
              </div>
            </Form>
          </Spin>
          <Modal
            title="授权协议查看"
            open={authInfoModal}
            width={900}
            footer={
                   [
                     <Button key="skip" onClick={() => setAuthInfoModal(false)}>
                       取消
                     </Button>,
                     <Button
                       type="primary"
                       key="confirm"
                       onClick={() => {
                         setAuthInfoModal(false);
                         form.setFieldsValue({ authorize: true });
                       }}
                     >
                       确认
                     </Button>,
                   ]
                 }
            onCancel={() => setAuthInfoModal(false)}
          >
            <div dangerouslySetInnerHTML={{ __html: AuthorizationInfo }} style={{ maxHeight: 600, overflowY: 'scroll' }} />
          </Modal>
        </div>
      </div>
    </div>
  );
}
